<a id="overview"></a>
<div class="rows">
  <div class="row">
    <div class="col-md-12 column mb-3">
      <div class="row">
        <div class="col-md-6">
          <div class="description pt-md-4 pb-0">
            <h5 class="mb-2"><strong>Description</strong></h5>
            @if (descriptionHtml) {
              <div class="js-description-short" [hidden]="showFull">
                {{ shortDescription }}
                @if (canToggle) {
                  <p>
                    <small>
                      <strong>
                        <a href="#" (click)="toggle($event)"
                          ><span class="icon ib-angle-down"></span> View full Description</a
                        >
                      </strong>
                    </small>
                  </p>
                }
              </div>
              <div class="js-description-full" [hidden]="!showFull">
                <div [innerHTML]="descriptionHtml"></div>
                @if (canToggle) {
                  <p>
                    <small>
                      <strong>
                        <a href="#" (click)="toggle($event)"
                          ><span class="icon ib-angle-up"></span> Hide full Description</a
                        >
                      </strong>
                    </small>
                  </p>
                }
              </div>
            } @else {
              <p class="ib-preview-empty">No description yet</p>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="description pt-md-4 pt-0">
            <h5 class="mb-2"><strong>Amenities</strong></h5>
            @if ((item.amenities?.length ?? 0) > 0) {
              <ul>
                @for (amenity of item.amenities; track amenity.amenity) {
                  <li>{{ amenity.amenity }}</li>
                }
              </ul>
            } @else {
              <p class="ib-preview-empty">No amenities listed</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
